var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export default function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    "], ["\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    "]))).join('');
}
var templateObject_1;
